import routerConstant from "./routerConstant";

export const navigationList = [
  {
    name: "회원 관리",
    current: "member",
    href: routerConstant.MEMBER.list,
  },
  {
    name: "장지 관리",
    current: "burial",
    href: routerConstant.BURIAL.list,
  },
  {
    name: "추천 리스트",
    current: "recommend",
    href: routerConstant.RECOMMEND.list,
  },
  {
    name: "신청 정보",
    current: "contact",
    children: [
      {
        name: "추모공원",
        href: routerConstant.PARKCONSULTING.list,
        current: "parkConsulting",
      },
      {
        name: "이장/개장",
        href: routerConstant.ASKGRAVEMOVE.list,
        current: "askGraveMove",
      },
      {
        name: "묘 조성",
        href: routerConstant.GRAVE.list,
        current: "grave",
      },
      {
        name: "상조",
        href: routerConstant.FUNERAL.list,
        current: "funeral",
      },
      {
        name: "상속상담",
        href: routerConstant.INHERITANCE.list,
        current: "inheritance",
      },
      {
        name: "생전/유품정리",
        href: routerConstant.MEMORY.list,
        current: "memory",
      },
    ],
  },
  {
    name: "디지털 추모",
    current: "digital",
    children: [
      {
        name: "병풍",
        href: routerConstant.FOLDINGSCREEN.list,
        current: "foldingScreen",
      },
      {
        name: "상차림",
        href: routerConstant.TABLESETTING.list,
        current: "tableSetting",
      },
    ],
  },
  {
    name: "블로그 컨텐츠",
    href: routerConstant.BLOG.list,
    current: "blog",
  },
  {
    name: "서비스 사례",
    href: routerConstant.CASES.list,
    current: "cases",
  },
  {
    name: "공지사항 관리",
    href: routerConstant.NOTICE.list,
    current: "notice",
  },
  {
    name: "한줄 공지 관리",
    href: routerConstant.ONELINENOTICE.list,
    current: "onelineNotice",
  },
  {
    name: "리뷰 관리",
    href: routerConstant.REVIEW.list,
    current: "review",
  },
  {
    name: "FAQ 관리",
    href: routerConstant.FAQ.list,
    current: "faq",
  },
  {
    name: "1:1문의 내역",
    href: routerConstant.INQUIRY.list,
    current: "inquiry",
  },
  {
    name: "입점 제휴 문의",
    href: routerConstant.COOPERATE.list,
    current: "cooperate",
  },
  {
    name: "알림톡",
    href: routerConstant.ALIMTALK.index,
    current: "alimtalk",
  },
];
